/* eslint-disable no-unused-vars */
import React from 'react';
import { useSelector } from 'react-redux';

export default function Connector(props) {
  const { positions } = props;
  const activeButton = useSelector((state) => state.data.activeButton);

  const { x = 0, y = 0, height = 0 } = positions?.[activeButton] || {};

  const nibRatio = 0.5;
  const CAP_H = 14;
  const WIDTH = 14;
  const STROKE = 1.5;
  const strokeColour = '#f0f0f0';

  const stemHeight = Math.max(0, height - CAP_H * 2);
  const nibY = CAP_H + stemHeight * nibRatio;

  return (
    <div
      className="connector"
      style={{
        transform: `translate(${x}px, ${y}px)`,
        height,
        width: WIDTH,
      }}
    >
      <svg
        className="cap capTop"
        width={WIDTH}
        height={CAP_H}
        viewBox={`0 0 ${WIDTH} ${CAP_H}`}
      >
        <path
          d={`M1 1 C7 1 7 6 7 ${CAP_H}`}
          fill="none"
          stroke={strokeColour}
          strokeWidth={STROKE}
          vectorEffect="non-scaling-stroke"
        />
      </svg>

      <div
        className="stemWrap"
        style={{
          top: CAP_H,
          height: stemHeight,
          width: WIDTH,
        }}
      >
        <svg
          className="stemSvg"
          width={WIDTH}
          height="100%"
          viewBox={`0 0 ${WIDTH} 100`}
          preserveAspectRatio="none"
        >
          <path
            d="M7 0 V100"
            fill="none"
            stroke={strokeColour}
            strokeWidth={STROKE}
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      </div>

      <svg
        className="nib"
        width={WIDTH}
        height={8}
        viewBox={`0 0 ${WIDTH} 8`}
        style={{ top: nibY - 4 }}
      >
        <path
          d="M7 4 H13"
          fill="none"
          stroke={strokeColour}
          strokeWidth={STROKE}
          vectorEffect="non-scaling-stroke"
        />
      </svg>

      <svg
        className="cap capBottom"
        width={WIDTH}
        height={CAP_H}
        viewBox={`0 0 ${WIDTH} ${CAP_H}`}
      >
        <path
          d={`M7 0 C7 ${CAP_H - 6} 7 ${CAP_H - 1} 1 ${CAP_H - 1}`}
          fill="none"
          stroke={strokeColour}
          strokeWidth={STROKE}
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </div>
  );
}
